import { CommonModule } from '@angular/common';
import {
  Component,
  ChangeDetectionStrategy,
  Input,
  Output,
  EventEmitter,
} from '@angular/core';
import { LetDirective } from '@directives/app-let.directive';
import { ModalModeEnum } from '@constants/modals.constants';
import { Store } from '@ngrx/store';
import { selectShouldUseMobileStyling } from '@selectors/app.selector';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { MessageComponent } from '@components/message/message.component';
import { OnTapDirective } from '@directives/on-tap/on-tap.directive';
import { TooltipModule } from 'ngx-bootstrap/tooltip';
import { selectRouteParam } from '@selectors/router.selector';
import { CULTURE_ROUTE_PARAM, CultureKeyType } from '@constants/app.constants';
import { Observable } from 'rxjs';

@Component({
  selector: 'app-no-bags-modal',
  standalone: true,
  templateUrl: './no-bags-modal.component.html',
  styleUrls: ['./no-bags-modal.component.scss'],
  imports: [
    CommonModule,
    LetDirective,
    MessageComponent,
    OnTapDirective,
    TooltipModule,
  ],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class NoBagsModalComponent {
  @Input() modalMode: ModalModeEnum;

  readonly ModalModeEnum = ModalModeEnum;

  @Output() response = new EventEmitter<boolean>();

  shouldUseMobileStyling$ = this.store.select(selectShouldUseMobileStyling);
  culture$ = this.store.select(
    selectRouteParam(CULTURE_ROUTE_PARAM),
  ) as Observable<CultureKeyType | undefined>;

  constructor(
    public bsModalRef: BsModalRef,
    private store: Store,
  ) {}

  onCancelClick(): void {
    this.response.emit(false);
    this.bsModalRef.hide();
  }

  onPrimaryClick(): void {
    this.response.emit(true);
    this.bsModalRef.hide();
  }
}
